export default "__VITE_ASSET__tblgQ2nU__"